import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
let WorkFlowEditTitleComponent = /** @class */ (() => {
    let WorkFlowEditTitleComponent = class WorkFlowEditTitleComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.workFlowName = "";
        }
        closeWorkflowTitle() {
            this.$emit("close-popup");
        }
        saveTitle() {
            this.validate("workFlowTitleObserver").then((response) => {
                if (response) {
                    this.$emit("save-name", this.workFlowName);
                }
            });
        }
        created() {
            this.workFlowName = this.name;
            this.$nextTick(() => {
                this.setFocusToInputAndSelect("workflowHeaderTitle");
            });
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], WorkFlowEditTitleComponent.prototype, "name", void 0);
    WorkFlowEditTitleComponent = __decorate([
        Component({
            name: "WorkFlowEditTitleComponent",
        })
    ], WorkFlowEditTitleComponent);
    return WorkFlowEditTitleComponent;
})();
export default WorkFlowEditTitleComponent;
